<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="4" fill="#FFE3E3"/>
<path d="M12 5C15.871 5 19 8.136 19 12C19 15.871 15.871 19 12 19C8.136 19 5 15.871 5 12C5 8.136 8.136 5 12 5ZM11.755 8.451C11.468 8.451 11.23 8.682 11.23 8.976V12.511C11.23 12.693 11.328 12.861 11.489 12.959L14.233 14.597C14.317 14.646 14.408 14.674 14.506 14.674C14.681 14.674 14.856 14.583 14.954 14.415C15.101 14.17 15.024 13.848 14.772 13.694L12.28 12.21V8.976C12.28 8.682 12.042 8.451 11.755 8.451Z" fill="#982E2E"/>
</svg>
</template>
<script lang="ts" setup>

</script>
